import { Input } from "antd";
import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";

export const GlobalFilter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter);
  const onChange = useAsyncDebounce((val) => {
    setFilter(val || undefined);
  }, 1000);
  return (
    <span className="mb-2">
      Search:{" "}
      <Input
        style={{ width: 200 }}
        placeholder="Search Globally"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
      />
    </span>
  );
};
